<template>
  <div>
    <div id="theme-customizer">
      <vs-sidebar
        click-not-close
        hidden-background
        position-right
        notLineActive="true"
        v-model="activeSide"
        class="items-no-padding"
      >
        <div class="h-full">
          <div
            class="
              customizer-header
              mt-6
              flex
              items-center
              justify-between
              px-6
            "
          >
            <div>
              <h4>THEME CUSTOMIZER</h4>
              <small>Customize & Preview in Real Time</small>
            </div>
            <feather-icon
              icon="XIcon"
              @click.stop="activeSide = false"
              class="cursor-pointer"
            ></feather-icon>
          </div>

          <vs-divider class="mb-0" />

          <VuePerfectScrollbar
            class="scroll-area--customizer pt-4 pb-6"
            :settings="settings"
            :key="$vs.rtl"
          >
          </VuePerfectScrollbar>
        </div>
      </vs-sidebar>
    </div>
    <!-- <vs-button color="primary" type="filled" @click="activeSide = true">activeSide</vs-button> -->
    <div class="router-content page-right-header">
      <vs-button color="primary" type="filled" @click="showAddEditDialog = true"
        >Add LR</vs-button
      >
    </div>
    <vs-popup
      fullscreen
      class="holamundo digitelex-popup"
      :title="modalTitle"
      :active.sync="showAddEditDialog"
    >
      <addEditLr
        :frmData="currentEditRow ? currentEditRow : formData"
        v-if="showAddEditDialog"
        @submitResponse="reloadData"
      ></addEditLr>
    </vs-popup>
    <div id="ag-grid-demo">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="
                  p-4
                  border border-solid
                  d-theme-border-grey-light
                  rounded-full
                  d-theme-dark-bg
                  cursor-pointer
                  flex
                  items-center
                  justify-between
                  font-medium
                "
              >
                <span class="mr-2">
                  {{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    lrs.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : lrs.length
                  }}
                  of {{ lrs.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="
              flex flex-wrap
              items-center
              justify-between
              ag-grid-table-actions-right
            "
          >
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()"
              >Export as CSV</vs-button
            >
          </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="lrs"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :context="context"
          :tooltipShowDelay="'0'"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
          @selection-changed="onSelectionChanged"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
          @change="changedPagination"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { EventBus } from "./../../../utils/grid/eventbus.js";
import addEditLr from "./add-edit-lr.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// define cellRenderer to be reused
//  @close="close" -> For popup props
let actionsTemplate = {
  template: `<div class="flex">
      <vs-button class="w-1/2 h-12 flex"  @click="editLr" size="medium" radius color="primary" type="flat" icon-pack="feather" v-if="params.data.consignmentStatus!=5 || sessionRoleId == 1 ||  sessionRoleId == 2" icon="icon-edit"></vs-button>
      <vs-button class="w-1/2 h-12 flex" @click="deleteLr" size="medium" radius color="danger" type="flat" icon-pack="feather" v-if="params.data.consignmentStatus!=5" icon="icon-trash"></vs-button>
      <vs-button class="w-1/2 h-12 flex" @click="copyLr" size="medium" radius color="primary" type="flat" icon-pack="feather" icon="icon-copy"></vs-button>
</div>`,
  data() {
    return {
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId
    };
  },
  methods: {
    editLr() {
      EventBus.$emit("editLr", { item: this.params });
    },
    deleteLr() {
      EventBus.$emit("deleteLr", { item: this.params });
    },
    copyLr() {
      EventBus.$emit("copyLr", { item: this.params });
    }
  },
  beforeMount() {
    // console.log(this.sessionRoleId);
  }
};
let printTemplate = {
  template: `<div class="flex">
   <vx-tooltip text="Print LR" position="top"  >
  <vs-button class="w-1/2 h-12 flex" @click="showLr" size="large"radius color="primary" type="flat" icon-pack="material-icons" icon="api"></vs-button>
  </vx-tooltip>
  <vx-tooltip text="Print Freight" position="top" v-if="params.data.toBranchId == branchId || sessionRoleId == 1 || sessionRoleId == 2">
      <vs-button class="w-1/2"  @click="showFreight" size="large"radius color="primary" type="flat" icon-pack="material-icons" icon="price_change"></vs-button>
  </vx-tooltip>
    </div>`,
  data() {
    return {
      branchId: JSON.parse(localStorage.getItem("sstUnData")).branchId,
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId
    };
  },
  methods: {
    showLr() {
      EventBus.$emit("showLr", { item: this.params });
    },
    showFreight() {
      EventBus.$emit("showFreight", { item: this.params });
    }
  },
  beforeMount() {}
};
export default {
  components: {
    "ag-grid-vue": AgGridVue,
    VuePerfectScrollbar: VuePerfectScrollbar,
    // eslint-disable-next-line vue/no-unused-components
    actionsTemplate: actionsTemplate,
    // eslint-disable-next-line vue/no-unused-components
    printTemplate: printTemplate,
    addEditLr: addEditLr
  },
  beforeMount() {
    // this.gridApi.showLoadingOverlay();
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      activeSide: false,
      showAddEditDialog: false,
      currentEditRow: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      context: null,
      modalTitle: "Add Lr",
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,
      formData: {
        isActive: true,
        consignmentLrNo: null,
        fromBranchId: null,
        toBranchId: null,
        consignmentId: null,
        consignmentPaymentStatus: null,
        consignmentEwayBillNo: null,
        consignmentProductValue: null,
        consignmentProductInvoiceNo: null,
        consignmentPaymentPaidThrough: null,
        consignmentPaymentRefNo: null,
        consignorId: null,
        consignmentConsignorMobileNo: null,
        consignmentConsignorGstNo: null,
        consignmentConsignorAddress: null,
        consigneeId: null,
        consignmentConsigneeMobileNo: null,
        consignmentConsigneeGstNo: null,
        consignmentConsigneeAddress: null,
        packages: [],
        additionalComments: [],
        consignor: {},
        consignee: {},
        consignmentFreightCharge: 0,
        consignmentHamaliCharge: 0,
        consignmentStationaryCharge: 0,
        consignmentSurCharge: 0,
        consignmentUnloadingCharge: 0,
        consignmentLrCopyCharge: 0,
        consignmentDoorDeliveryCharge: 0,
        consignmentOtherCharge: 0,
        consignmentTotalCharge: 0,
        consignmentCGstCharge: 0,
        consignmentSGstCharge: 0,
        consignmentGrandTotalCharge: 0,
        consignmentComment: null
      },
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,

        suppressRowClickSelection: false,
        rowSelection: "multiple",
        // onSelectionChanged: onSelect,
        enableCellTextSelection: true
      },
      columnDefs: [
        {
          headerName: "Actions",
          width: 150,
          filter: false,
          pinned: "left",
          cellRendererFramework: "actionsTemplate"
          // checkboxSelection: true,
        },
        {
          headerName: "Print",
          headerTooltip: "Print",
          width: 100,
          filter: false,
          pinned: "left",
          cellRendererFramework: "printTemplate"
        },
        {
          headerName: "Lr No",
          headerTooltip: "Lr No",
          field: "consignmentLrNo",
          width: 150,
          filter: true,
          tooltipField: "consignmentLrNo",
          pinned: "left",
          valueFormatter: _params => {
            if (_params.value) {
              let zero = 10 - _params.value.toString().length + 1;
              return Array(+(zero > 0 && zero)).join("0") + _params.value;
            }
          }
        },
        {
          headerName: "Status",
          field: "consignmentStatusName",
          width: 150,
          filter: true,
          tooltipField: "consignmentStatusName",
          pinned: "left"
        },
        {
          headerName: "From",
          headerTooltip: "From",
          field: "consignmentFromBranchName",
          filter: true,
          width: 200,
          tooltipField: "consignmentFromBranchName"
        },
        {
          headerName: "To",
          headerTooltip: "To",
          field: "consignmentToBranchName",
          filter: true,
          width: 200,
          tooltipField: "consignmentToBranchName"
        },
        {
          headerName: "Current Branch",
          headerTooltip: "Current Branch",
          field: "consignmentCurrentBranch",
          filter: true,
          width: 200,
          tooltipField: "consignmentCurrentBranch"
        },
        {
          headerName: "Consignor",
          field: "consignmentConsignorData",
          headerTooltip: "Consignor",
          filter: true,
          width: 200,
          tooltipField: "consignmentConsignorData"
        },
        {
          headerName: "Consignee",
          headerTooltip: "Consignee",
          field: "consignmentConsigneeData",
          filter: true,
          width: 180,
          tooltipField: "consignmentConsigneeData"
        },
        {
          headerName: "Way Bill",
          headerTooltip: "Way Bill",
          field: "consignmentEwayBillNo",
          filter: true,
          width: 180,
          tooltipField: "consignmentEwayBillNo"
        },
        {
          headerName: "Payment Type",
          headerTooltip: "Payment Type",
          field: "consignmentPaymentStatusName",
          filter: true,
          width: 180,
          tooltipField: "consignmentPaymentStatusName"
        },
        {
          headerName: "Description",
          headerTooltip: "Description",
          field: "consignmentComment",
          filter: true,
          width: 250,
          tooltipField: "consignmentComment"
        },
        {
          headerName: "No of Articles",
          headerTooltip: "No of Articles",
          field: "consignmentPackagesTotalCnt",
          filter: true,
          width: 250,
          tooltipField: "consignmentPackagesTotalCnt"
        },
        {
          headerName: "Freight Charge",
          headerTooltip: "Freight Charge",
          field: "consignmentFreightCharge",
          filter: true,
          width: 250,
          tooltipField: "consignmentFreightCharge"
        },
        {
          headerName: "Total Charge",
          headerTooltip: "Total Charge",
          field: "consignmentGrandTotalCharge",
          filter: true,
          width: 250,
          tooltipField: "consignmentGrandTotalCharge"
        }
      ],
      lrs: [],
      gridCurrentPage: 1,
      allLrs: [],
      totalCount: 0,
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2025/"
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        // this.gridOptions.columnApi.setColumnPinned("vehicleNo", null);
      }
      //   else this.gridOptions.columnApi.setColumnPinned("vehicleNo", "left");
    },
    showAddEditDialog: function() {
      Object.keys(this.formData).forEach(key => {
        if (typeof key === "string") this.formData[key] = "";
        else if (typeof key === "boolean") this.formData[key] = false;
        else if (typeof key === "number") this.formData[key] = 0;
        else this.formData[key] = "";
      });
      if (!this.showAddEditDialog) {
        this.currentEditRow = false;
      }
      this.formData.fromBranchId = JSON.parse(
        localStorage.getItem("sstUnData")
      ).branchId;
      this.formData.consignmentPaymentStatus = 3;
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      // return 100;
      return Math.ceil(this.totalCount / 10);

      // if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      // else return 0;
    },
    currentPage: {
      get() {
        return this.gridCurrentPage;
        // if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        // else return 1;
      },
      set(_val) {
        return this.gridCurrentPage;
        // this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      // selectedRows.length === 1 ? selectedRows[0].athlete : '';
    },
    changedPagination(e) {
      // console.log(
      //   "M-fetching data for:",
      //   e,
      //   this.gridCurrentPage,
      //   e > this.gridCurrentPage,
      //   this.lrs.length,
      //   e * 10,
      //   this.lrs.length < e * 10
      // );
      if (this.gridCurrentPage == 1) {
        this.gridCurrentPage = e;
        this.getDynamicData();
      } else if (e > this.gridCurrentPage) {
        this.gridCurrentPage = e;
        // console.log("Fetching new records");
        this.getDynamicData();
      } else {
        this.gridCurrentPage = e;
        this.gridApi.paginationGoToPage(this.gridCurrentPage - 1);
      }

      // if(this.gridCurrentPage)
      // else if (this.gridCurrentPage < e) this.getDynamicData();
      // else this.gridApi.paginationGoToPage(this.gridCurrentPage - 1);
    },
    getDynamicData() {
      // console.log(
      //   "S-fetching data for:",
      //   this.gridCurrentPage,
      //   this.lrs.length,
      //   this.gridCurrentPage * 10
      // );
      if (this.lrs.length >= this.gridCurrentPage * 10) {
        // console.log("fetching data for: No Server Call");
        this.gridApi.paginationGoToPage(this.gridCurrentPage - 1);
      } else {
        this.gridApi.showLoadingOverlay();
        // console.log(
        //   "fetching data for: Server Call",
        //   this.lrs.length >= this.gridCurrentPage * 10
        // );
        this.$http
          .post("portage/lrs", {
            lastNumber: this.gridCurrentPage * 10,
            search: this.searchQuery
          })
          .then(response => {
            console.log(response);
            if (response.data.data.length > 0) {
              this.gridApi.hideOverlay();
              // this.allLrs = response.data.data;
              this.lrs.push(...response.data.data);
              this.totalCount = response.data.totalCount;
              this.gridApi.setRowData(this.lrs);
              this.gridApi.paginationGoToPage(this.gridCurrentPage - 1);
              // this.lrs = JSON.parse(JSON.stringify(response.data.data));
              // console.log(this.allLrs);
            } else {
              this.gridApi.showNoRowsOverlay();
            }
          });
      }
    },
    reloadData(_event) {
      this.showAddEditDialog = false;
      this.allLrs = _event.data.data;
      this.totalCount = _event.data.totalCount;

      this.$vs.notify({
        title: _event.data.message,
        color: "success",
        position: "top-right"
      });
      this.gridApi.setRowData(_event.data.data);
    },
    openPrintLrLink(lr) {
      const url =
        this.pdfUrl +
        "lrview.php?lrno=" +
        btoa(lr.consignmentLrNo) +
        "&token=" +
        localStorage.getItem("sessionToken");
      // alert(url);
      window.open(url, "_blank");
      return false;

      // window.open(
      //   url,
      //   "_blank",
      //   "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      // );
    },
    deleteLr(_e) {
      this.$http
        .put("portage/lr", _e.data)
        .then(response => {
          // text:'Lorem ipsum dolor sit amet, consectetur',

          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right"
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.showLoadingOverlay();
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while loading Lrs</span>';
    this.overlayNoRowsTemplate =
      '<span class="ag-overlay-loading-center">No Lrs found!</span>';
    this.context = {
      componentParent: this
    };
    // this.$http.get("portage/lrs").then(response => {
    //   if (response.data.data.length > 0) {
    //     this.gridApi.hideOverlay();
    //     this.allLrs = response.data.data;
    //     this.lrs = JSON.parse(JSON.stringify(response.data.data)).slice(0, 10);
    //     console.log(this.allLrs);
    //   } else {
    //     this.gridApi.showNoRowsOverlay();
    //   }
    // });
    EventBus.$on("editLr", memoData => {
      this.currentEditRow = memoData.item.data;
      this.showAddEditDialog = true;
    });
    EventBus.$on("copyLr", _lrData => {
      let thisIns = this;
      const lrData = _lrData;
      let showedMessage = false;
      let copyString = `Lr No : ${lrData.item.data.consignmentLrNo}\nFrom: ${lrData.item.data.consignmentFromBranchName}\nTo: ${lrData.item.data.consignmentToBranchName}\nStatus: *${lrData.item.data.consignmentStatusName}*\nConsignor:${lrData.item.data.consignor.consignmentConsignorName} ${lrData.item.data.consignor.consignmentConsignorMobileNo}\nConsignee: ${lrData.item.data.consignee.consignmentConsigneeName} ${lrData.item.data.consignee.consignmentConsigneeMobileNo}\nQuantity:${lrData.item.data.consignmentPackagesTotalCnt}`;
      copyString = copyString.toString();
      this.$copyText(copyString).then(function() {
        if (!showedMessage) {
          showedMessage = true;
          thisIns.$vs.notify({
            title: "Success",
            text: "LR Data Copied Successfully",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle"
          });
        }
      });
      return false;

      // setTimeout(() => window.copy("copied!"), 0);

      // window.copy(lrData.data);
    });
    EventBus.$on("showLr", lr => {
      this.openPrintLrLink(lr.item.data);
    });

    EventBus.$on("showFreight", lr => {
      console.log(lr);
      if (lr.item.data.consignmentFreightNo) {
        //code
        const url =
          this.pdfUrl +
          "freightreceiptpdf.php?lrno=" +
          btoa(lr.item.data.consignmentId) +
          "&token=" +
          localStorage.getItem("sessionToken");
        window.open(url, "_blank");
        return false;

        //  window.open(
        //   url,
        //   "_blank",
        //   "location=yes,height=570,width=520,scrollbars=yes,status=yes"
        // );
      } else {
        this.$vs.notify({
          title: "Freight was not generated!Please try lateral",
          color: "danger",
          position: "top-right"
        });
      }
      // console.log(lr);
    });

    EventBus.$on("deleteLr", memoData => {
      // this.currentEditRow = clientData.item.data;
      let rowData = memoData;
      rowData.item.data.isActive = false;
      console.log(memoData);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Memo?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.deleteLr,
        parameters: rowData.item
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to delete below Memo?<br/><blockquote>Memo No: <b>${rowData.item.data.consignmentLrNo}</b></blockquote>`;
        }
      }, 0);
    });
  }
};
</script>
<style scoped>
.digitelex-popup .vs-popup {
  width: 56vw;
}
</style>

<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 9999999;
    width: 600px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.customizer-btn {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;

  .vs-icon {
    animation: spin 1.5s linear infinite;
  }
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
}
</style>
